<div class="array-list-modal">
  <div class="modal-content">
    <div class="array-list">
      <div class="array-row" *ngFor="let item of items">
        <ng-container *ngIf="itemTemplate; else defaultRow">
          <ng-container
            [ngTemplateOutlet]="itemTemplate"
            [ngTemplateOutletContext]="{ $implicit: item }">
          </ng-container>
        </ng-container>
        <ng-template #defaultRow>
          {{ formatItem(item) }}
        </ng-template>
      </div>
    </div>
  </div>
</div>